<section id="ng-for-business-form" class="contact-form">
  <h2 class="ng-title">
    READY TO GET <br class="d-sm-none" />STARTED?
  </h2>
  <p class="ng-subtitle">
    Whether you’re looking to offer a perk, support employee health, or simply simplify lunch breaks,
    NutriGenic is here to help.
  </p>
  <app-contact-form />
</section>
